import { apiClient } from '@/api/client';
import type { LoginResponseData, UserDto } from '@/types/api';

export const authApi = {
  login: (data: { account: string; password: string; captcha?: string }) =>
    apiClient.post<unknown, LoginResponseData>('/auth/login', data),

  logout: () => apiClient.post<unknown, null>('/auth/logout'),

  refresh: () =>
    apiClient.post<unknown, { token: string; token_type: string; expires_in: number }>(
      '/auth/refresh',
    ),

  me: () => apiClient.get<unknown, UserDto>('/users/me'),
};
